(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(e) {
      e.preventDefault();
      const { closeAnnouncement } = e.target.dataset;
      if (closeAnnouncement === 'row') {
        e.target.closest('.announcement-bar__row').remove();
      } else {
        this.remove();
      }
    }

    connectedCallback() {
      if (this.querySelector('.announcement-bar__close')) {
        this.querySelector('.announcement-bar__close').addEventListener('click', this.handleClick.bind(this));
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    

  class FooterCollapsible extends HTMLElement {

    constructor() {

      super();



      this.details = this.querySelector('details');

      this.summary = this.querySelector('summary');

      this.summaryIsEmpty = this.summary.textContent.trim().length == 0;

      this.openDefault = this.dataset.openDefault === 'true';



      this.details.addEventListener(

        'keyup',

        (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()

      );

      this.summary.addEventListener('click', this.onSummaryClick.bind(this));

      document.addEventListener('matchTablet', this.close.bind(this));

      document.addEventListener('unmatchTablet', this.open.bind(this));



      if (FoxThemeSettings.isTablet) {

        if (!this.openDefault) this.close();

      }



      document.addEventListener('matchTablet', () => {

        if (!this.openDefault) {

          this.close();

        } else {

          this.open();

        }

      });



      document.addEventListener('unmatchTablet', () => {

        this.open();

      });

    }



    onSummaryClick(event) {

      event.preventDefault();

      event.target.closest('details').hasAttribute('open')

        ? this.close()

        : this.open();

    }



    open() {

      this.details.setAttribute('open', true);

    }



    close() {

      !this.summaryIsEmpty && this.details.removeAttribute('open');

    }

  }



  customElements.define('footer-collapsible', FooterCollapsible);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super();
      document.body.classList.add('mobile-sticky-bar-enabled');
    }

    connectedCallback() {
      document.documentElement.style.setProperty('--f-mobile-navbar-height', this.offsetHeight + 'px');
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar);

  } catch(e) { console.error(e); }
})();
})();
